/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
import { groupConstants } from '../constants/groupConstants';
import { groupServices } from '../services/groupServices';
import { toastError, toastSuccess } from './alertActions';

function getAll(companyId) {
  return (dispatch, getState) => {
    dispatch(request(companyId));
    groupServices.getAll(companyId)
      .then(
        (group) => {
          sessionStorage.setItem('group', JSON.stringify(group));
          dispatch(success(group));
        },
        (error) => {
          dispatch(failure(error.toString()));
        },
      );
  };

  function request(group) { return { type: groupConstants.GET_ALL_GROUPS_REQUEST, group }; }
  function success(group) { return { type: groupConstants.GET_ALL_GROUPS_SUCCESS, group }; }
  function failure(error) { return { type: groupConstants.GET_ALL_GROUPS_FAILURE, error }; }
}

function deleteUserGroup(groupId, userId) {
  return (dispatch, getState) => {
    dispatch(request(groupId));
    groupServices.deleteUserGroup(groupId, userId)
      .then(
        (data) => {
          toastSuccess('Utilisateur retiré avec succés du groupe');
          dispatch(success(data));
        },
        (error) => {
          toastError(error.toString());
          dispatch(failure(error.toString()));
        },
      );
  };

  function request(group) { return { type: groupConstants.DELETE_USER_GROUP_REQUEST, group }; }
  function success(group) { return { type: groupConstants.DELETE_USER_GROUP_SUCCESS, group }; }
  function failure(error) { return { type: groupConstants.DELETE_USER_GROUP_FAILURE, error }; }
}

function getGroupById(groupId) {
  return (dispatch, getState) => {
    dispatch(request(groupId));
    groupServices.getGroupById(groupId)
      .then(
        (groups) => {
          dispatch(success(groups));
        },
        (error) => {
          dispatch(failure(error.toString()));
        },
      );
  };

  function request() { return { type: groupConstants.GETGROUPBYID_REQUEST }; }
  function success(groupById) { return { type: groupConstants.GETGROUPBYID_SUCCESS, groupById }; }
  function failure(error) { return { type: groupConstants.GETGROUPBYID_FAILURE, error }; }
}

function setSelectedSubGroup(subgroup) {
  return (dispatch, getState) => {
    sessionStorage.setItem('selectedSubGroup', JSON.stringify(subgroup));
    dispatch({ type: groupConstants.SET_SELECTED_SUBGROUP, subgroup });
  };
}

function setSelectedGroup(group) {
  return (dispatch, getState) => {
    sessionStorage.setItem('selectedGroup', JSON.stringify(group));
    dispatch({ type: groupConstants.SET_SELECTED_GROUP, group });
  };
}

/*        return (dispatch, getState) => {

        var newGroup = {...group};

            if (group.idTeachers && group.idTeachers !== []) {

                teacherServices.getTeacherById(group.idTeachers[0])
                .then(response => {
                    //newGroup.idTeachers[0] = response
                      sessionStorage.setItem("selectedGroup", JSON.stringify(newGroup) )
                     dispatch({type: groupConstants.SET_SELECTED_GROUP, newGroup })
                });
            }

        }
        */
export const groupActions = {
  getAll,
  deleteUserGroup,
  setSelectedSubGroup,
  getGroupById,
  setSelectedGroup,
};
